export default __webpack_public_path__ + "static/media/roles-permission-white.94dce45f.svg";